<template lang="pug">
.doc-participation-card
  .card-section
    .card-section-header
      .card-section-icon.card-section-icon--green
        icon(name='file-lines')
      .card-section-title {{ $t('modal.envelope.documentInfo') }}
    ul.nav.flex-column.info-card-list
      li(v-if='document.name')
        small.text {{ $t('modal.envelope.documentName') }}: {{ document.name }}
      li(v-if='document.type')
        small.text {{ $t('modal.envelope.documentType') }}: {{ document.type }}
      li(v-if='document.stage')
        small.text {{ $t('modal.envelope.documentStage') }}: {{ document.stage }}
      li(v-if='document.size')
        small.text {{ $t('modal.envelope.documentSize') }}: {{ formatFileSize(document.size) }}
  .card-section(v-if='recipient')
    .card-section-header
      .card-section-icon.card-section-icon--blue
        icon(name='user-check')
      .card-section-title {{ $t('modal.envelope.yourParticipation') }}
    ul.nav.flex-column.info-card-list
      li(v-if='role')
        small.text {{ $t('modal.envelope.yourRole') }}: {{ role }}
      li(v-if='recipient.state && isSigner')
        small.text.me-1 {{ $t('modal.envelope.documentStatus') }}:
        status-badge(:status='recipient.state')
      li(v-if='isSigner !== null && isRecipientSignerType')
        info-pill(:active='isSigner' :icon='isSigner ? "signature" : "eye"') {{ isSigner ? $t('modal.envelope.isSignerInDocument') : $t('modal.envelope.isNotSignerInDocument') }}
  .doc-card-footer(v-if='document.sha1')
    small.doc-card-hash SHA1: {{ document.sha1 }}
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import StatusBadge from '@/modules/business/components/molecules/StatusBadge.vue';
import InfoPill from '@/modules/business/components/molecules/InfoPill.vue';
import RecipientType from '@/enums/RecipientType';

export default {
  name: 'DocumentParticipationCard',
  components: {
    Icon,
    StatusBadge,
    InfoPill,
  },
  props: {
    document: {
      type: Object,
      default: () => ({}),
    },
    recipient: {
      type: Object,
      default: null,
    },
    role: {
      type: String,
      default: '',
    },
    isSigner: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    isRecipientSignerType() {
      return (
        this.recipient?.type === RecipientType.SIGNER ||
        this.recipient?.type === RecipientType.IN_PERSON_SIGNER
      );
    },
  },
  methods: {
    formatFileSize(bytes) {
      const units = ['B', 'KB', 'MB', 'GB'];
      let value = bytes;
      let unitIndex = 0;
      while (value >= 1024 && unitIndex < units.length - 1) {
        value /= 1024;
        unitIndex += 1;
      }
      return `${value.toFixed(unitIndex === 0 ? 0 : 2)} ${units[unitIndex]}`;
    },
  },
};
</script>

<style scoped lang="stylus">
.doc-participation-card
  background-color: #fff
  border: 1px solid rgba(204, 204, 204, .5)
  border-radius: 8px
  padding: 1.25rem
  margin-bottom: 1.25rem

.card-section
  & + .card-section
    margin-top: 1.25rem
    padding-top: 1.25rem
    border-top: 1px solid rgba(204, 204, 204, .5)

.card-section-header
  display: flex
  align-items: center
  gap: 0.75rem
  margin-bottom: 1rem

.card-section-icon
  display: flex
  align-items: center
  justify-content: center
  flex: 0 0 auto
  width: 2rem
  height: 2rem
  border-radius: 50%
  font-size: 0.9rem

  &--green
    background-color: #E7F0EF
    color: #19665B

  &--blue
    background-color: #EAF1FB
    color: #2C6FBB

.card-section-title
  font-weight: 600
  font-size: 0.95rem

.info-card-list
  gap: 0.6rem
  li
    display: flex
    align-items: center
    flex-wrap: wrap
    row-gap: 0.35rem
    line-height: 1.4

.pill
  white-space: normal
  text-align: left

.doc-card-footer
  margin-top: 1rem
  padding-top: 0.75rem
  border-top: 1px solid rgba(204, 204, 204, .5)

.doc-card-hash
  display: block
  font-size: 0.65rem
  font-family: monospace
  color: #ADB5BD
  word-break: break-all
</style>
